/* 🤖 this file was generated by svg-to-ts */
export const matIconBolt: {
  name: 'bolt';
  data: string;
} = {
  name: 'bolt',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M11 21h-1l1-7H7.5c-.88 0-.33-.75-.31-.78C8.48 10.94 10.42 7.54 13.01 3h1l-1 7h3.51c.4 0 .62.19.4.66C12.97 17.55 11 21 11 21z"/></svg>`
};
